<template>
  <div :id="id" class="inc-container" :class="{ visible: visible }">
      <div class="inc-body">
      <span class="close-x" @click="changeIncVisib(agp)" :class="{'visible': agp.incVisible}">X</span>
        <div class="inc" v-for="pratos in incidences">
          <span
            v-for="(ptData, key) in pratos"
            :key="key"
            v-text="ptData.name || ptData.value || ptData || '0'"
            :class="{ sumiu: ptData.visible == false, verm: ptData && ptData.value == 'Ø' } "
          ></span>
        </div>
      </div>
  </div>
</template>

<script>

import { t } from 'i18next'

export default {
  name: "DistributionOfIncidences",
  props: ["incidences", "visible", "agp"],
  data() {
    return {
      id: new Date().getMilliseconds()
    };
  },
  methods: {
    scrollHorizontally: function (e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      document.getElementById(this.id).scrollLeft -= delta * 40; // * by 40
      e.preventDefault();
    },
    changeIncVisib: function(agp){
     this.$emit('changeVisOfDistribuition', agp);
    }
  },
  mounted(){
    document.getElementById(this.id).addEventListener( "mousewheel", this.scrollHorizontally, false);
  },
  watch: {
    visible: function () {
      this.visible;
    },
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.inc-container {
  font-size: 13px;
}
.inc-body {
  span.close-x.visible {
    cursor: pointer;
    display: table;
    position: sticky;
    padding: 5px;
    top: 0;
    left: 0;
    color: red;
    font-weight: bold;
}
  .sombra;
    //overflow: auto;
    position: relative;
    background: white;
    width: auto;
    margin: auto;
    pointer-events: auto;
    // top: 50%;
    // transform: translate(0, -50%);
    margin: auto;
    // left: 0%;
    // display: table;
  .inc {
    display: block;
    white-space: nowrap;
    span {
      padding: 5px 5px;
      display: inline-block;
      font-size: 13px;
      width: 150px;
      text-align: center;
      white-space: normal;
      &.verm{
        color: red;
      }
    }
    span:first-of-type {
      left: 0;
      background: @azul;
      color: #fff;
      position: sticky;
    }
    span:not(:first-of-type) {
      text-align: center;
    }
    span:nth-of-type(2),span:nth-of-type(3),span:nth-of-type(4),span:nth-of-type(5){
      width: 30px;
    }
    &:first-of-type {
      background: @azul;
      position: sticky;
      top: 0;
      z-index: 1;
      span {
        vertical-align: bottom;
        background: @azul;
        color: #fff;
      }
      span:first-of-type {
        padding-left: 5px;
        margin: auto 0;
      }
      span:not(:first-of-type) {
      }
    }
    &:nth-of-type(2n) {
      span:not(:first-of-type) {
        background: rgba(196, 196, 196, 0.2);
      }
    }
  }
}
</style>